<template>
    <div>
        <minhas-licitacoes-titulo-secao titulo="Tenho Interesse"/>
        <minhas-licitacoes-tabela :itens="itens" :paginas="paginas" :total-itens="totalItens" :favoritos=true
                                  :paginacao="$store.state.licitacoesFavoritasFornecedorBusca.paginacao"
                                  @paginar="eventoPaginar"
                                  @visualizar="eventoVisualizar" @acaoPrincipal="eventoEnviarProposta"/>
    </div>
</template>

<script>
    import {mapActions, mapMutations} from 'vuex'
    import {actionTypes, mutationTypes} from '@/commons/constants'
    import MinhasLicitacoesTabela from './MinhasLicitacoesTabela'
    import MinhasLicitacoesTituloSecao from './MinhasLicitacoesTituloSecao'

    export default {
        name: 'MinhasLicitacoesFavoritas',
        components: {MinhasLicitacoesTituloSecao, MinhasLicitacoesTabela},
        data() {
            return {
                itens: [],
                paginas: 0,
                totalItens: 0
            }
        },
        methods: {
            ...mapActions([actionTypes.BUSCAR_LICITACOES_FAVORITAS_FORNECEDOR]),
            ...mapMutations([mutationTypes.SET_PAGINACAO_BUSCA_LICITACOES_FAVORITAS_FORNECEDOR]),
            abrirTelaAceitarTermosProposta(licitacao) {
                this.$router.push({
                    name: 'licitacaoFornecedorItens',
                    params: {
                        id: licitacao.id,
                        iniciarCredenciamento: true
                    }
                })
            },
            abrirTelaProposta(licitacao) {
                this.$router.push({
                    name: 'licitacaoFornecedorProposta',
                    params: {
                        id: licitacao.id
                    }
                })
            },
            async buscar() {
                this.setMensagemLoading('Carregando Licitações...')
                const resultado = await this.buscarLicitacoesFavoritasFornecedor()
                this.itens = resultado.content
                this.paginas = resultado.totalPages
                this.totalItens = resultado.totalElements
            },
            eventoPaginar(paginacao) {
                this.setPaginacaoBuscaLicitacoesFavoritasFornecedor(paginacao)
                this.buscar()
            },
            eventoVisualizar(licitacaoId) {
                this.$router.push({name: 'licitacaoFornecedor', params: {id: licitacaoId}})
            },
            eventoEnviarProposta(licitacao) {
                if (licitacao.aceitouTermos) {
                    this.abrirTelaProposta(licitacao)
                } else {
                    this.abrirTelaAceitarTermosProposta(licitacao)
                }
            }
        }
    }
</script>